import Style from 'ol/style/Style'
import Fill from 'ol/style/Fill'

import {createLayer} from "../helpers";
import { geoServerWmsUrl, qualifiedGeoServerLayer, getGeoServerWorkspace } from '../geoserver.js'

export async function getViabilityMapLayers() {
    const workspace = getGeoServerWorkspace()
    const ruasLayer = qualifiedGeoServerLayer('geo_ruas_novo', workspace)
    const zonasLayer = qualifiedGeoServerLayer('geo_viabilidade', workspace)
    const layers = [
        {
            layer_type: 'VectorLayer',
            description: 'Viabilidade',
            active: true,
            display_in_layer_switcher: false,
            name: 'Viabilidade',
            zIndex: 1,
            geo_table: 'viabilidade.geo_coordenadas_zoneamento',
            style: new  Style ({
                fill: new Fill({color: 'transparent'})
            })
        },
        {
            layer_type: 'VectorLayer',
            description: 'Ruas Vetor',
            active: true,
            display_in_layer_switcher: false,
            name: 'Ruas Vetor',
            zIndex: 2,
            geo_table: 'public.geo_ruas',
            style: new  Style ({
                fill: new Fill({color: 'transparent'})
            })
        },
        {
            layer_type: 'ImageLayer',
            description: 'Ruas',
            active: true,
            url: geoServerWmsUrl(),
            font: ruasLayer,
            name: 'Ruas',
            zIndex: 3,
            display_in_layer_switcher: true,
            params: JSON.stringify({'layers': ruasLayer, 'TILED': true}),
            opacity: 0.5,
        },
        {
            layer_type: 'ImageLayer',
            description: 'Zonas',
            display_in_layer_switcher: true,
            active: true,
            url: geoServerWmsUrl(),
            font: zonasLayer,
            name: 'Zonas',
            zIndex: 4,
            params: JSON.stringify({'layers': zonasLayer, 'TILED': true}),
            opacity: 0.75,
        }
    ]


    const layerPromises = layers.map(createLayer);
    const resolvedLayers = await Promise.all(layerPromises);

    return resolvedLayers.filter(item => item !== null).reverse();
}

export function setupZoneamentoTooltip(map, {
    zones,
    tooltipElement,
    getZoneamentoId = feature => feature.get('zoneamento_id'),
    onZoneChange = () => {},
    activePopoverCoordinateRef = null,
    modalRef = null
}) {
    let lastZoneamentoId = null
    map.on('pointermove', (evt) => {
        const pixel = evt.pixel
        const feature = map.forEachFeatureAtPixel(pixel, f => f)
        if (feature) {
            const zoneamentoId = getZoneamentoId(feature)

            if (evt.originalEvent.clientX + tooltipElement.offsetWidth > window.innerWidth) {
                tooltipElement.style.left = `${evt.originalEvent.clientX - tooltipElement.offsetWidth - 20}px`
            } else {
                tooltipElement.style.left = `${evt.originalEvent.clientX}px`
            }
            tooltipElement.style.top = `${evt.originalEvent.clientY}px`

            if (zoneamentoId !== lastZoneamentoId) {
                lastZoneamentoId = zoneamentoId

                const zone = zones.value.find(zn => zn.id === zoneamentoId)

                if (zone) {
                    tooltipElement.innerHTML = `<strong>${zone.description}</strong> - ${zone.objective}`
                    tooltipElement.style.opacity = '1'

                    onZoneChange(zone)
                } else {
                    tooltipElement.style.opacity = '0'
                }
            }
        } else {
            tooltipElement.style.opacity = '0'
            lastZoneamentoId = null
        }
    })

    map.on('moveend', () => {
        if (activePopoverCoordinateRef?.value && modalRef?.value?.updatePopoverPosition) {
            const pixel = map.getPixelFromCoordinate(activePopoverCoordinateRef.value)
            modalRef.value.updatePopoverPosition(pixel)
        }
    })

    map.getViewport().addEventListener('mouseleave', () => tooltipElement.style.opacity = '0')
    map.getViewport().addEventListener('mouseenter', () => tooltipElement.style.opacity = '1')
}

export const getCoordinateByPropertyId = async (propertyId) => {
    let coordinate = (await window.axios.get(`/api/viabilidade/search/matricula/${propertyId}`)).data.data
    return [parseFloat(coordinate[0].longitude), parseFloat(coordinate[0].latitude)]
}
